module.exports = __webpack_public_path__ + "img/my-tasks-empty-state.4bfc3dd4.svg";